import { ValidatorFn } from '@angular/forms';
import { CarmValidatorsList } from '@carm/_utils/error-handler/validations/carm-validators';
import { IKeyValue } from '@carm/_utils/models';
import { EditFieldControlTypeEnum } from './edit-field-control-type.enum.model';
import { EditFieldMetadataTypeEnum } from './edit-field-metadata-type.enum.model';

export class EditFieldBase<T> {
    value: string;
    key: string;
    editFieldValue: T;
    required: boolean;
    order: number;
    controlType: EditFieldControlTypeEnum;
    options: IKeyValue[];
    metadataType?: EditFieldMetadataTypeEnum;
    i18nText?: string;
    validators?: ValidatorFn[];

    constructor(options: {
        value?: string;
        key?: string;
        editFieldValue?: T;
        required?: boolean;
        order?: number;
        controlType?: EditFieldControlTypeEnum;
        options?: IKeyValue[];
        metadataType?: EditFieldMetadataTypeEnum;
        i18nText?: string;
        validators?: ValidatorFn[];
    }) {
        this.value = options.value;
        this.key = options.key;
        this.editFieldValue = options.editFieldValue;
        this.required = options.required;
        this.order = options.order;
        this.controlType = options.controlType;
        this.options = options.options;
        this.metadataType = options.metadataType;
        this.i18nText = options.i18nText;
        this.validators = options.validators;
        if (this.required && !options.validators) {
            this.validators = [CarmValidatorsList.required.validateFn()];
        }
    }
}
